import Select from "react-select";
import { Controller, Control, FieldError } from "react-hook-form";

interface FormSelectProps {
    label?: string;
    options: any[];
    name: string;
    control: Control<any>;
    isMulti?: boolean;
    closeMenuOnSelect?: boolean;
    placeholder?: string;
    className?: string;
    noOptionsMessage?: string;
    errors?: FieldError;
    disabled?: boolean;
    required?: boolean;
}

const FormSelect = ({
    label,
    options,
    name,
    control,
    isMulti = false,
    closeMenuOnSelect = true,
    placeholder = '',
    className = '',
    noOptionsMessage = 'Không có dữ liệu',
    errors,
    disabled,
    required
}: FormSelectProps) => {

    const customStyles = {
        control: (provided: any, state: any) => ({
          ...provided,
          padding: 3,
          borderColor: state.isFocused ? "#2563eb" : "#d1d5db",
          boxShadow: state.isFocused ? "0 0 0 1px #2563eb" : "none",
          "&:hover": {
            borderColor: "#2563eb",
          },
          minHeight: 38,
        }),
        option: (provided: any, state: any) => ({
          ...provided,
          backgroundColor: state.isSelected
            ? "#2563eb"
            : state.isFocused
            ? "#e0e7ff"
            : undefined,
          color: state.isSelected ? "white" : "#111827",
          "&:active": {
            backgroundColor: "#2563eb",
            color: "white",
          },
          fontSize: 15,
        }),
        menu: (provided: any) => ({
          ...provided,
          zIndex: 10,
        }),
        singleValue: (provided: any) => ({
          ...provided,
        //   color: "#111827",
        //   fontWeight: 500,
        }),
        placeholder: (provided: any) => ({
          ...provided,
          color: "#9ca3af",
          fontSize: 15,
        }),
      };
      
    return (
        <div className={className}>
            {label && <label className="block text-sm font-medium mb-1 text-gray-700" htmlFor={name}>{label}{required && <span className="text-red-500"> *</span>}</label>}
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <Select
                        isDisabled={disabled}
                        options={options}
                        value={options.find(option => option.value === field.value)}
                        onChange={option => field.onChange(option ? option.value : null)}
                        isMulti={isMulti}
                        closeMenuOnSelect={closeMenuOnSelect}
                        placeholder={placeholder}
                        noOptionsMessage={() => noOptionsMessage}
                        styles={customStyles}
                    />
                )}
            />
            {errors && <div className="text-red-500 text-xs mt-1 block">{errors.message}</div>}
        </div>
    );
};

export default FormSelect;